/**
 * Created by han on 1/9/2019.
 */

import PreloadAnimation from './animation';

/*
 * events :
 * 	loading		- DOM
 * 	interactive	- DOM
 * 	complete	- DOM
 * 	loaded		- WINDOW
 * */

class Preload {

	constructor (window, document) {
		this.window = window;
		this.document = document;
		this._loaded = false;

		// once
		this._loadingOnce = false;
		this._interactiveOnce = false;
		this._completeOnce = false;
	}

	init(context) {
		this.setListeners();
		this.setTicking( context );
	}

	getDOMReadyState() {
		const readyState = this.document.readyState;

		return {
			loading: readyState === 'loading',
			interactive: readyState === 'interactive',
			complete: readyState === 'complete',
		};
	}

	getLoaded() {
		return {
			loaded: this._loaded
		};
	}

	setListeners() {
		// load
		this.window.addEventListener('load', () => {
			this._loaded = true;
		});
	}

	setTicking(context) {
		const preload = this;
		let tickVal = 50;
		let timeout = null;

		(function ticking() {
			const emitters = { ...preload.getDOMReadyState(), ...preload.getLoaded() };
			Object.keys( emitters ).forEach( event => {
				if ( event === 'loading' && !preload._loadingOnce ) {
					preload._loadingOnce = true;
					context.emit(event);
				}
				if (event === 'interactive' && !preload._interactiveOnce) {
					preload._interactiveOnce = true;
					context.emit(event);
				}
				if (event === 'complete' && !preload._completeOnce) {
					preload._completeOnce = true;
					context.emit(event);
				}
			});
			if ( !preload._loaded ) {
				timeout = setTimeout(ticking, tickVal);
			} else {
				clearTimeout(timeout);
				context.emit('loaded');
			}
		}());
	}
}

const preload = new Preload(window, document);

export default {
	name: 'Preload',
	Preload: preload,
	on: {
		'init': function () {
			this.Preload.init(this);
		},
		'interactive': function () {
			PreloadAnimation(this);
		}
	},
};